import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ChartOptions, ChartType } from 'chart.js';
import { Color } from 'ng2-charts';
import { LocalizedDatePipe } from 'src/app/shared/pipes/localized-date/localized-date.pipe';

@Component({
  selector: 'aum-cli-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss']
})
export class LineChartComponent implements OnInit, OnChanges {
  @Input() dailyChanges;
  @Input() showLabels = false;
  chartLabels = [];
  chartData = [];
  chartType: ChartType = 'line';
  chartLegend = false;
  public chartOptions: ChartOptions;
  public chartColors: Color[] = [
    {
      borderColor: '#fcd861',
      backgroundColor: 'rgba(80,76,73, 0.5)'
    }
  ];

  constructor(private datePipe: LocalizedDatePipe) {}

  ngOnInit(): void {
    this.initChartData();
  }

  ngOnChanges(): void {
    this.initChartData();
  }

  initChartData(): void {
    this.chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        datalabels: {
          formatter: ctx => {
            return ctx.chart.data.labels[ctx.dataIndex];
          }
        }
      },
      elements: {
        point: {
          radius: 3,
          pointStyle: 'circle',
          borderWidth: 2,
          borderColor: '#fcd861',
          hoverRadius: 8
        }
      },
      hover: {
        mode: 'x-axis',
        intersect: false
      },
      tooltips: {
        mode: 'x-axis',
        intersect: false,
        bodyAlign: 'center',
        bodyFontColor: '#fcd861',
        bodyFontStyle: 'bold',
        displayColors: false,
        titleAlign: 'center',
        titleFontColor: '#B1B1B1',
        xPadding: 15,
        yPadding: 8
      },
      scales: {
        xAxes: [
          {
            ticks: {
              stepSize: 3
            },
            display: this.showLabels,
            gridLines: {
              display: false
            }
          }
        ],
        yAxes: [
          {
            display: false
          }
        ]
      }
    };
    this.chartData = this.dailyChanges.map(
      item => Math.round(item.price * 10000) / 10000
    );
    this.chartLabels = this.dailyChanges.map(item => {
      return this.datePipe.transform(item.date, 'dd/MM');
    });
  }
}
